import { ExchangeRate, ExchangeRateOrigin } from '../types/exchangeRate';

/** Manual/backdated USD/LKR rates (Phase 104) — shared formatting. */

const pad = (n: number) => String(n).padStart(2, '0');

export const formatRateDateTime = (iso: string | Date) => {
  const d = new Date(iso);
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** A rate with 2–4 decimals ("310.25", "310.2575"). */
export const formatRate = (rate: number | string) =>
  Number(rate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 });

export const formatMoney = (amount: number) =>
  amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const rateOriginLabel = (origin: ExchangeRateOrigin | null | undefined) =>
  origin === 'MANUAL' ? 'Manual' : 'Automatic';

export const rateSourceText = (rate: Pick<ExchangeRate, 'origin' | 'source'>) =>
  rate.origin === 'MANUAL' ? 'Manual rate (IMC Finance)' : `${rate.source} — TT Selling (automatic)`;

/** One-line description of a rate for menus and confirmations. */
export const describeRate = (rate: ExchangeRate) =>
  `Rs. ${formatRate(rate.rate)} · effective ${formatRateDateTime(rate.sourcePublishedAt)} · ${
    rate.origin === 'MANUAL'
      ? `Manual${rate.publishedBy ? ` by ${rate.publishedBy.firstName} ${rate.publishedBy.lastName}` : ''}`
      : 'Nations Trust (automatic)'
  }`;

/** A <input type="datetime-local"> value for a Date, in local time. */
export const toDateTimeLocal = (d: Date) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
